import React from 'react';
import { envConfig, isProduction } from '../config/env';

const EnvIndicator: React.FC = () => {
  // 生产环境不显示环境指示器
  if (isProduction()) {
    return null;
  }

  const getEnvColor = () => {
    switch (envConfig.ENV) {
      case 'development':
        return 'bg-green-500';
      case 'test':
        return 'bg-yellow-500';
      case 'production':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getEnvText = () => {
    switch (envConfig.ENV) {
      case 'development':
        return '开发';
      case 'test':
        return '测试';
      case 'production':
        return '生产';
      default:
        return '未知';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className={`${getEnvColor()} text-white px-3 py-1 rounded-full text-xs font-medium shadow-lg`}>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
          <span>{getEnvText()}环境</span>
        </div>
      </div>
      
      {/* 详细信息悬浮提示 */}
      <div className="absolute top-full right-0 mt-2 bg-gray-900 text-white text-xs rounded-lg p-3 opacity-0 hover:opacity-100 transition-opacity duration-200 pointer-events-none hover:pointer-events-auto min-w-[200px]">
        <div className="space-y-1">
          <div><strong>环境:</strong> {envConfig.ENV}</div>
          <div><strong>API:</strong> {envConfig.API_BASE_URL}</div>
          <div><strong>开发模式:</strong> {envConfig.isDevelopment ? '是' : '否'}</div>
          <div><strong>测试模式:</strong> {envConfig.isTest ? '是' : '否'}</div>
        </div>
      </div>
    </div>
  );
};

export default EnvIndicator; 